/* LogHighlightRules.js */

"use strict";

class LogHighlightRules {
    static getLogHighlightRules() {
        return {
            start: [
                {regex: /(^\s*)(\. )(.*$)/, token: "info"},
                {regex: /(^\s*)(\(\*\) )(.*$)/, token: "checkpoint"},
                {regex: /(^\s*)((?:>>|<<) )(.*$)/, token: "task"},
                {regex: /(^\s*)(__ )(.*$)/, token: "debug"},
                {regex: /(^\s*)(!\? )(.*$)/, token: "warning"},
                {regex: /(^\s*)(\?\? )(.*$)/, token: "error"},
                {regex: /(^\s*)(XX)(.*$)/, token: "error"},
                {regex: /^\s*\d+} .*$/, token: "resp"},
                {defaultToken: "default"},
            ],
        };
    }
}

module.exports = LogHighlightRules;
